<button (click)="getLogas()"
        [size]="size"
        class="mr-2"
        nbButton
        nbTooltip="Logas {{name}}"
        status="danger">
    <i class="far fa-key fa-fw"></i>&nbsp;
</button>
